import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import axios from "axios";


const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,          // for new file (File object)
    fileName: "",
    filePath: "",
    remarks: "",
    isNew: true,         // ✅ identify new file
    fullUrl: "",         // ✅ for existing file preview
});
const CreateUnitMaster = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const userName = useSelector(getName);
    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false,]);
    const [loading, setloader] = useState(false)
    // Master Listings
    const [measurementList, setMeasurementList] = useState([]);
    const [salersList, setSalesPersonList] = useState([]);
    const [bedRoomList, setBedRoomList] = useState([]);
    const [landlordList, setLandlordList] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [communityList, setcommunityList] = useState([]);
    const [unitTypeList, setUnitTypeList] = useState([]);
    const [unitViewList, setunitViewList] = useState([]);
    const [imageView, setImageView] = useState([]);
    const [unitCategoryList, setunitCategoryList] = useState([]);
    const [floorList, setFloorList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [countriesList, setCountries] = useState([]);
    const [cityList, setCityList] = useState([]);
    // Unit Listings
    const [manDateList, setManDateList] = useState([]);
    const [reserveAccList, setReserveAccList] = useState([]);
    const [keyStatusList, setKeyStatusList] = useState([]);
    const [unitCostList, setUnitCostList] = useState([]);
    const [paymentPlan, setPaymentPlan] = useState([]);
    const [projectStatus, setProjectStatus] = useState([]);
    const [costAccount, setCostAccount] = useState([]);
    const [agent, setAgent] = useState([]);
    const [furnishing, setFurnishing] = useState([]);
    const [refferedBy, setRefferedBy] = useState([]);
    const [enteredBy, setEnteredBy] = useState([]);
    const [furniturePlan, setFurniturePlan] = useState([]);
    const [period, setPeriod] = useState([]);
    const [sizeType, setSizeType] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [currencyList, setCurrency] = useState([]);
    const [featuresList, setFeaturesList] = useState([]);
    const [attachments, setAttachments] = useState([createEmptyRow()]);

    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    const validationRules = [
        { key: "property", message: "Please Select Property" },
        { key: "unitNo", message: "Please Enter Unit No" },
        { key: "unitClass", message: "Please Enter Unit Class" },
        { key: "unitType", message: "Please Enter Unit Type" },
        { key: "unitCategory", message: "Please Enter Unit Category" },
        { key: "unitView", message: "Please Enter Unit View" },
        { key: "bedRooms", message: "Please Enter Bed Room" },
        { key: "totalArea", message: "Please Enter Total Area" },
    ];
    const [transectionData, setTransectionData] = useState({
        saller: null,
        landlordId: null,
        property: null,
        community: null,
        unitType: null,
        unitCategory: null,
        country: null,
        city: null,
        unitView: null,
        floor: null,
        bedRooms: null,
        unitNo: '',
        contactPerson: '',
        municipltyNo: '',
        refNo: '',
        unitClass: '',
        sector: '',
        block: '',
        bathRoom: '',
        balcony: '',
        livingarea: '',
        terraceArea: '',
        totalArea: '',
        parking: '',
        unitRate: '',
        remarks: '',
        parkingPrice: '',
        resale: false,
    });
    const [unitDetails, setUnitDetails] = useState({
        mandate: null,
        reservedAccCode: null,
        statusKey: null,
        unitCost: null,
        paymentPlan: null,
        status: null,
        costAccount: null,
        agent: null,
        furnishing: null,
        refferedBy: null,
        enteredBy: null,
        furniturePlan: null,
        unitModel: '',
        serviceCharge: '',
        unitStyle: '',
        reservedFund: '',
        storeRoom: '',
        plotNO: '',
        company: '',
        financeOffered: '',
        plotSize: '',
        additionalWorkCost: '',
        streetNo: '',
        opt2Cost: '',
        opt3Cost: '',
        furnitureCost: '',
        occupied: false,
        propertyRegistered: false,
        leased: false,
        completionDate: formattedDate,
        expiryDate: formattedDate,
        reffferedDate: formattedDate,
        enteredDate: formattedDate,
        modifiedDate: formattedDate,
    });
    const [salesDetails, setSalesDetails] = useState({
        currency: null,
        orignalPrice: '',
        orignalRateSqft: '',
        profit: '',
        profitCalculate: '',
        listingPrice: '',
        listingPriceRate: '',
        priceinothercontry: '',
        mainSalePrice: '',
        marketAnalysis: '',
        to: '',
        commPaid: '',
        commPaidCalculate: '',
        commSeller: '',
        commSellerCalculate: '',
        sellerTransferFee: '',
        sellerTransferFeeCalcu: '',
        buyerTransferFee: '',
        buyerTransferFeeCalcu: '',
        legalFee: '',
        legalFeeCalcu: '',
        miscFee: '',
        miscFeeCalcu: '',
        comment: '',
        sellerPaidDev: '',
        sellerPaidDevCalcu: '',
        amountDueDev: '',
        amountDueDevCalcu: '',
    });
    const [buyerSummery, setBuyerSummery] = useState({
        sellerTransfer: '',
        developerBalance: '',
        developerBalancePerc: '',
        BuyerCommission: '',
        BuyerCommissionPerc: '',
        DlDTransfer: '',
        DlDTransferPerc: '',
        administrationFee: '',
        administrationFeePerc: '',
        otherFee: '',
        otherFeePerc: '',
        allPrice: '',
        allPricePerc: '',
    });
    const [leaseDetails, setLeaseDetails] = useState({
        dueDate: formattedDate,
        rentPerAnum: '',
        rentByMonth: '',
        rentPerDay: '',
        securityDeposit: '',
        securityDepositPerc: '',
        tenantCommission: '',
        tenantCommissionPerc: '',
        landlordCommission: '',
        landlordCommissionPerc: '',
        maintenanceFee: '',
        rentPayable: '',
        IbanNo: '',
        secDepositPayable: '',
        commissionPayable: '',
        bankName: null,
        accountNo: '',
        fixedCharges: '',
        variableCharges: '',
        installment: '',
    });

    useEffect(() => {
        fetchDropdownData()
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMAreaMeasurements,UMSalesPersons,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods,');
            const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
            const scndparams = new URLSearchParams();
            scndparams.append('dropdownTypes', 'UMSellerNames,UMReservedFundAccounts,UMAccounts,UMBanks,UMPaymentPlans,UMCountries,UMFurnished,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies');
            const scndRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${scndparams.toString()}`);
            setBedRoomList(res?.data?.dropdowns?.UMBedrooms)
            setCostAccount(res?.data?.dropdowns?.UMCostAccounts)
            setEnteredBy(res?.data?.dropdowns?.UMEnteredBy)
            setFloorList(res?.data?.dropdowns?.UMFloors)
            setImageView(res?.data?.dropdowns?.UMImageTypes)
            setKeyStatusList(res?.data?.dropdowns?.UMKeyStatus)
            setManDateList(res?.data?.dropdowns?.UMMandate)
            setPeriod(res?.data?.dropdowns?.UMPeriods)
            setPropertyList(res?.data?.dropdowns?.UMProperties)
            setRefferedBy(res?.data?.dropdowns?.UMReferredBy)
            setSizeType(res?.data?.dropdowns?.UMSizeTypes)
            setunitCategoryList(res?.data?.dropdowns?.UMUnitCategories)
            setunitViewList(res?.data?.dropdowns?.UMUnitViews)
            setUnitTypeList(res?.data?.dropdowns?.UMUnitTypes)
            setAgent(scndRes?.data?.dropdowns?.UMAgents)
            setProjectStatus(scndRes?.data?.dropdowns?.UMProjectStatus)
            setcommunityList(scndRes?.data?.dropdowns?.UMCommunities)
            setMeasurementList(scndRes?.data?.dropdowns?.UMAreaMeasurements)
            setUnitCostList(scndRes?.data?.dropdowns?.UMEnteredBy)
            setLandlordList(scndRes?.data?.dropdowns?.UMSellers)
            setSalesPersonList(scndRes?.data?.dropdowns?.UMSellers)
            setBankList(scndRes?.data?.dropdowns?.UMBanks)
            setPaymentPlan(scndRes?.data?.dropdowns?.UMPaymentPlans)
            setCountries(scndRes?.data?.dropdowns?.UMCountries)
            setFurnishing(scndRes?.data?.dropdowns?.UMFurnishing)
            setCurrency(scndRes?.data?.dropdowns?.UMCurrencies)
            setFurniturePlan(scndRes?.data?.dropdowns?.UMFurniturePlans)
            setReserveAccList(scndRes?.data?.dropdowns?.UMReservedFundAccounts)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setloader(true);
            for (const rule of validationRules) {
                if (!transectionData?.[rule.key]) {
                    setloader(false);
                    toast.warning(rule.message);
                    return;
                }

            }
            if (!salesDetails?.listingPrice) {
                setloader(false);
                toast.warning("Please Enter Listing Price");
                return;
            } else if (!unitDetails?.enteredBy?.label) {
                setloader(false);
                toast.warning("Please Select Entered By User");
                return;
            }

            const scndparams = new URLSearchParams();
            scndparams.append('Action', 'CheckDuplicateUnit');
            scndparams.append('PropertyNo', transectionData?.property?.value?.value);
            scndparams.append('UnitNo', transectionData?.unitNo);
            const scndRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${scndparams.toString()}`);
            const duplicateCheck = scndRes?.data?.result?.data?.[""];

            if (duplicateCheck === 1) {
                toast.warning("Unit already exists for this property");
                setloader(false);
                return;
            }
            const unitFeatures = featuresList?.map((item, index) => {
                return {
                    status: item?.DescType || "0",
                    description: item?.Description || "0",
                    value: item?.Value,
                    cnt: parseFloat(item?.Cnt) || 0,
                    amount: parseFloat(item?.Amount) || 0,
                    isNewInEdit: item?.IsNewInEdit === 0 ? false : true
                }
            });
            const body = {
                unitMasterMain: {
                    unitMaster: {
                        ref_No: transectionData?.refNo || "0",
                        property_No: transectionData?.property?.value?.value || "0",
                        property_Name: transectionData?.property?.label || "0",
                        unit_No: transectionData?.unitNo || "0",
                        rerA_STR_No: "0",
                        street_No: unitDetails?.streetNo || "0",
                        street_Name: "0",
                        unit_Type: transectionData?.unitType?.label || "0",
                        unit_Category: transectionData?.unitCategory?.label || "0",
                        unit_Style: unitDetails?.unitStyle || "0",
                        unit_Model: unitDetails?.unitModel || "0",
                        unit_Zone: "0",
                        plot_No: unitDetails?.plotNO || "0",
                        plot_Size: unitDetails?.plotSize || "0",
                        block: transectionData?.block || "0",
                        floor: transectionData?.floor?.label || "0",
                        unit_View: transectionData?.unitView?.label || "0",
                        completion_Date: unitDetails?.completionDate,
                        unit_Class: transectionData?.unitClass || "0",
                        livingRooms: transectionData?.livingarea || "0",
                        bedrooms: transectionData?.bedRooms?.label || "0",
                        storeRooms: unitDetails?.storeRoom || "0",
                        parking: transectionData?.parking || "0",
                        facilities: "0",
                        status: unitDetails?.status?.label || "0",
                        payment_Plan: unitDetails?.paymentPlan?.label || "0",
                        broker_Name: unitDetails?.agent?.label || "0",
                        seller_Id: transectionData?.landlordId?.label || "0",
                        seller_Name: transectionData?.saller?.label || "0",
                        adv_Listing: true,
                        adv_OpenHouse: true,
                        adv_Remarks1: "0",
                        adv_Remarks2: "0",
                        adv_Remarks3: "0",
                        remarks: transectionData?.remarks || "0",
                        internalRemarks: transectionData?.remarks || "0",
                        otherSpace1: "0",
                        bathrooms: transectionData?.bathRoom || "0",
                        balcony: transectionData?.balcony || "0",
                        terrace: transectionData?.terraceArea || "0",
                        total_Area: parseFloat(transectionData?.totalArea) || 0,
                        measured_Area: 0,
                        sqft_Rate: parseFloat(transectionData?.unitRate || 0),
                        purchase_Value: 0,
                        total_Value: 0,
                        measured_Value: 0,
                        roundOff_Value: 0,
                        parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
                        all_In_Price: 0,
                        premium: 0,
                        premium_Percent: 0,
                        seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
                        seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
                        buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
                        buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
                        seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
                        seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
                        buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
                        buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
                        admin_Fees: parseFloat(buyerSummery?.administrationFee) || 0,
                        admin_Fees_Percent: parseFloat(buyerSummery?.administrationFeePerc) || 0,
                        other_Fees: parseFloat(buyerSummery?.otherFee) || 0,
                        other_Fees_Percent: parseFloat(buyerSummery?.otherFeePerc) || 0,
                        other_Fees_Remarks: "0",
                        seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
                        seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
                        developer_Due: parseFloat(salesDetails?.amountDueDev) || 0,
                        developer_Due_Percent: parseFloat(salesDetails?.amountDueDevCalcu) || 0,
                        rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
                        short_Term_Rent: 0,
                        short_Term_Period: "0",
                        rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
                        security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
                        advance_Deposit: 0,
                        tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
                        landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
                        maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
                        negotiable: true,
                        currency: salesDetails?.currency?.label || "0",
                        cmA_Range1: 0,
                        cmA_Range2: 0,
                        installments: parseFloat(leaseDetails?.installment) || 0,
                        rentPayableTo: leaseDetails?.rentPayable || "0",
                        rentBankName: leaseDetails?.bankName?.label || "0",
                        rentBankAcNo: leaseDetails?.accountNo || "0",
                        secDepPayableTo: leaseDetails?.secDepositPayable || "0",
                        comPayableTo: leaseDetails?.commissionPayable || "0",
                        key_Status: unitDetails?.statusKey?.label || "0",
                        publishStatus: true,
                        serviceCharge: unitDetails?.serviceCharge || "0",
                        ownerOccupied: true,
                        leased: unitDetails?.leased || false,
                        leaseAmount: 0,
                        leaseExpiry: unitDetails?.expiryDate,
                        mandate: unitDetails?.mandate?.label || "0",
                        financeCompany: "0",
                        mortgaged: true,
                        mortgageCompany: "0",
                        propertyRegistered: true,
                        portfolio: 0,
                        portfolioManager: "0",
                        propertyType: "0",
                        factor: 0,
                        common: 0,
                        cp: 0,
                        effeciency: "0",
                        listingPriceUSD: 0,
                        monthlyIncome: "0",
                        annualIncome: "0",
                        exp9: "0",
                        exp10: "0",
                        refered_By: unitDetails?.refferedBy?.label || "0",
                        refered_On: unitDetails?.reffferedDate,
                        createdBy: userName || "0",
                        createdOn: today,
                        modifiedBy: userName || "0",
                        modifiedOn: today
                    },
                    unitFeatures: unitFeatures,
                    unitImages: [
                        {
                            record_Id: 0,
                            image_Description: "0",
                            image_Filename: "0",
                            isDefault: true,
                            folder: "0",
                            url: "0",
                            isAdded: false,
                            isUpdated: false,
                            isDeleted: false
                        }
                    ],
                    unitPayables: [
                        {
                            description: "0",
                            value: true,
                            landlord: true,
                            tenant: true
                        }
                    ],
                    unitYearlyRents: [
                        {
                            year: 0,
                            rentPerSqftRest: 0,
                            rentPerSqftKitchen: 0,
                            rentPerSqftTerrace: 0,
                            totalRent: 0,
                            scPerSqftRest: 0,
                            scPerSqftKitchen: 0,
                            scPerSqftTerrace: 0,
                            totalServiceCharge: 0,
                            chilledWaterPerSqftRest: 0,
                            chilledWaterPerSqftKitchen: 0,
                            chilledWaterPerSqftTerrace: 0,
                            totalChilledWaterCharge: 0
                        }
                    ],
                    unitFixedCharges: [
                        {
                            description: "0",
                            amount: 0
                        }
                    ]
                }
            }
            const postRes = await apiService.post('CREATE_UNIT', body);
            if (postRes?.data?.statusCode === 200 || postRes?.data?.statusCode === 201) {
                debugger
                if (attachments) {
                    handleUpload(postRes?.data?.result?.ref_No)
                }
                toast.success(postRes?.data?.message);
                setloader(false);
                navigate('/Customer/Property/Master/Unit/listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleUpload = async (ref_No) => {
        const formData = new FormData();


        let token = localStorage.getItem('Token');
        let db = localStorage.getItem('DataBase');
        // const validFiles = attachments.filter(
        //     (item) => item.file instanceof File
        // );
        const validFiles = attachments.filter(
            (item) => item.file instanceof File && item.isNew
        );

        validFiles.forEach(({ file }) => {
            formData.append("files", file);
        });

        formData.append("refNo", ref_No);
        formData.append("fileCategory", "Images");

        // ✅ DEBUG
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }

        const response = await axios.post(
            "https://lease.api.apps.rabahrain.com/api/FileUpload/unit-files",
            formData,
            {
                headers: {
                    accept: "text/plain",
                    apikey: "V+kBloEwqqVho1PINmQI0VJQwSBX2l/e",
                    Authorization: `Bearer ${token}`,
                    db: db,
                },
            }
        );
        if (response?.data) {
            additionalDataUpload(response?.data?.result, ref_No)
        }
    }
    const additionalDataUpload = async (data, refNo) => {
        const unitFeatures = featuresList?.map((item, index) => {
            return {
                status: item?.DescType || "0",
                description: item?.Description || "0",
                value: item?.Value,
                cnt: parseFloat(item?.Cnt) || 0,
                amount: parseFloat(item?.Amount) || 0,
                isNewInEdit: item?.IsNewInEdit === 0 ? false : true
            }
        });
        const image = data?.map((item, index) => {
            return {
                record_Id: 0,
                image_Description: item?.originalFileName || "0",
                image_Filename: item?.fileName || "0",
                isDefault: true,
                folder: item?.filePath || "0",
                url: item?.fullUrl || "0",
                isAdded: true,
                isUpdated: false,
                isDeleted: false
            }
        });
        debugger
        const body = {
            refNo: refNo || "0",
            unitFeatures: unitFeatures,
            unitImages: image,
            unitPayables: [
                {
                    description: "0",
                    value: true,
                    landlord: true,
                    tenant: true
                }
            ],
            unitYearlyRents: [
                {
                    year: 0,
                    rentPerSqftRest: 0,
                    rentPerSqftKitchen: 0,
                    rentPerSqftTerrace: 0,
                    totalRent: 0,
                    scPerSqftRest: 0,
                    scPerSqftKitchen: 0,
                    scPerSqftTerrace: 0,
                    totalServiceCharge: 0,
                    chilledWaterPerSqftRest: 0,
                    chilledWaterPerSqftKitchen: 0,
                    chilledWaterPerSqftTerrace: 0,
                    totalChilledWaterCharge: 0
                }
            ],
            unitFixedCharges: [
                {
                    description: "0",
                    amount: 0
                }
            ]
        }
        const postRes = await apiService.post('POST_UNIT_ADDITIONAL', body);

    }
    return (
        <div className='p-3'>
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className=''><h6>Unit Master</h6></div>
                <div className='d-flex gap-3'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Unit Master
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Unit Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}>Unit Features
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)}>Sales Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 4 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(4)}>Buyer Summery
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 5 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(5)}>Lease Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 6 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(6)}>Advertisement
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 7 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(7)}>Images
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<MasterDetails tableLoading={tableLoading} countriesList={countriesList} salersList={salersList} setCityList={setCityList}
                setTransectionData={setTransectionData} propertyList={propertyList} cityList={cityList} setFeaturesList={setFeaturesList}
                transectionData={transectionData} landlordList={landlordList} communityList={communityList} unitTypeList={unitTypeList} unitViewList={unitViewList}
                floorList={floorList} unitCategoryList={unitCategoryList} setcommunityList={setcommunityList} setunitCategoryList={setunitCategoryList}
                bedRoomList={bedRoomList}
            />)}
            {gridVisibility[1] && (<UnitDetails tableLoading={tableLoading} manDateList={manDateList} reserveAccList={reserveAccList} agent={agent}
                setTransectionData={setUnitDetails} keyStatusList={keyStatusList} unitCostList={unitCostList} paymentPlan={paymentPlan} furnishing={furnishing}
                transectionData={unitDetails} projectStatus={projectStatus} costAccount={costAccount} refferedBy={refferedBy} enteredBy={enteredBy} furniturePlan={furniturePlan}
            />)}
            {gridVisibility[2] && (<UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />)}
            {gridVisibility[3] && (<SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} />)}
            {gridVisibility[4] && (<BuyerSummery tableLoading={tableLoading} setTransectionData={setBuyerSummery} transectionData={buyerSummery} />)}
            {gridVisibility[5] && (<LeaseDetails tableLoading={tableLoading} setTransectionData={setBuyerSummery} transectionData={buyerSummery} bankList={bankList} />)}
            {gridVisibility[7] && (<ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />)}
        </div>

    );
};
export default CreateUnitMaster;